import { BASE_URL } from "../common/const";

// TEMPRORARY USE THIS BASE URL HERE AFTERWARDS MOVE TO HTTP CLIENT

const build = (path: string) => `${BASE_URL}${path}`;

// API ENDPOINTS DEFINITIONS
export const API_ENDPOINTS = {
  // ==================== AUTH ====================
  AUTH: {
    BASE: build("/api/Auth"),
    LOGIN: build("/api/Auth/Login"),
    FORGOT_PASSWORD: build("/api/Auth/ForgotPassword"),
    RESET_PASSWORD: build("/api/Auth/ResetPassword"),
    SET_PASSWORD: build("/api/Auth/SetPassword"),
    CHECK_IS_EXPIRE_INVITATION: build("/api/Auth/CheckIsExpireInvitation"),
    REFRESH_TOKEN: build("/api/Auth/RefreshToken"),
    INFO: build("/api/Auth/Info?"),
  },
  // ==================== ACCOUNT ====================
  ACCOUNT: {
    BASE: build("/api/Account"),
    LIST: build("/api/Account/GetList"),
    GET: build("/api/Account/{id}"),
    GET_MASTER_GROUP_LIST_FOR_SELECT: build(
      "/api/Account/GetMasterGroupListForSelect",
    ),
    GET_LIST_FOR_SELECT: build("/api/Account/GetListForSelect?"),
    GET_RECALULATE_LEDGER_SUMMARY: build(
      "/api/Account/GetRecalulateLedgerSummary?",
    ),
    GET_RECALULATE_STOCK_SUMMARY: build(
      "/api/Account/GetRecalulateStockSummary?",
    ),
    GET_DETAIL: build("/api/Account/GetDetail?"),
    CREATE: build("/api/Account/Create"),
    UPDATE: build("/api/Account/Update"),
    DELETE: build("/api/Account/Delete"),
    SEARCH: build("/api/Account/Search"),
    EXPORT: build("/api/Account/Export"),
    GET_ACCOUNTS_LIST_FOR_EXPENSE: build(
      "/api/Account/GetAccountsListForExpense?",
    ),
    GET_ACCOUNTS_FOR_EXPENSE_DYNAMIC_FIELD: build(
      "/api/Account/GetAccountsForExpenseDynamicField?",
    ),
    GET_ACCOUNTS_FOR_JOURNAL_VOUCHER_DYNAMIC_FIELD: build(
      "/api/Account/GetAccountsForJournalEnteriesDynamicField?",
    ),
    GET_MASTER_ACCOUNT_LIST: build("/api/Account/GetMasterAccountList?"),
    GET_MASTER_LEDGER_GROUP_LIST: build(
      "/api/Account/GetMasterLedgerGroupList?",
    ),
    GET_ACCOUNT_DETAIL_BY_PERAMETERS: build(
      "/api/Account/GetAccountDetailByPerameters?",
    ),
    GET_ACCOUNTS_FOR_SALES_REPORT: build(
      "/api/Account/GetAccountsForSalesReceipt?",
    ),
    GET_LEDGER_ACCOUNT_SUMMARY: build("/api/Account/GetLedgerAccountSummary?"),
    GET_LIST_BY_ACCOUNT_CODE: build("/api/Account/GetListByAccountCode?"),
    GET_LEDGER_GROUP_SUMMARY_DETAIL: build(
      "/api/Account/GetLedgerGroupSummaryDetail?",
    ),
  },
  // ==================== ACCOUNTS_TRANSFER ====================
  ACCOUNTS_TRANSFER: {
    BASE: build("/api/AcountsTransfer"),
    TRANSFER_ACCOUNTS: build("/api/AcountsTransfer/AccountTrasfer?"),
    TRANSFER_STOCKS: build("/api/AcountsTransfer/StockTrasfer?"),
  },
  // ==================== ADDON ====================
  ADDON: {
    BASE: build("/api/AddOn"),
    GET_LIST: build("/api/AddOn/GetList?"),
  },
  // ==================== ADMIN ====================
  ADMIN: {
    BASE: build("/api/Admin"),
    GET_DETAIL_BY_ID: build("/api/Admin/GetDetailById?"),
    GET_DETAIL: build("/api/Admin/GetDetail?"),
    LIST: build("/api/Admin/GetList?"),
    CREATE: build("/api/Admin/Create"),
    DELETE: build("/api/Admin/Delete"),
    UPDATE: build("/api/Admin/Update"),
    CHANGE_PASSWORD: build("/api/Admin/ForgotPassword"),
    SEND_INVITE: build("/api/Admin/SendInvite"),
  },
  // ==================== AREA ====================
  AREA: {
    BASE: build("/api/Area"),
    GET_DETAIL: build("/api/Area/GetDetail?"),
    LIST: build("/api/Area/GetList?"),
    CREATE: build("/api/Area/Create"),
    UPDATE: build("/api/Area/Update"),
    DELETE: build("/api/Area/Delete"),
    GET_AREAWISE_REPORT_LIST: build("/api/Area/GetArewiseReportList?"),
  },
  // ==================== BALANCE_SHEET ====================
  BALANCE_SHEET: {
    BASE: build("/api/BalanceSheet"),
    GET_LIST: build("/api/BalanceSheet/GetBalanceSheetList?"),
  },
  // ==================== BILL_OF_MATERIAL ====================
  BILL_OF_MATERIAL: {
    BASE: build("/api/BillOfMaterial"),
    GET_DETAIL: build("/api/BillOfMaterial/GetDetail?"),
    LIST: build("/api/BillOfMaterial/GetList?"),
    CREATE: build("/api/BillOfMaterial/Create"),
    UPDATE: build("/api/BillOfMaterial/Update"),
    DELETE: build("/api/BillOfMaterial/Delete"),
    GET_DETAIL_BOM: build("/api/BillOfMaterial/GetDetailBom?"),
    POSSIBLE_BOM_COUNT_BY_AVAILABLE_STOCK: build(
      "/api/BillOfMaterial/PossibleBOMCountByAvailableStock?",
    ),
  },
  // ==================== WHATSAPP ====================
  WHATSAPP: {
    BASE: build("/api/Whatsapp"),
    STATUS: build("/api/Whatsapp/status"),
    SEND: build("/api/Whatsapp/send"),
  },
  // ==================== WAREHOUSE ====================
  WAREHOUSE: {
    BASE: build("/api/Warehouse"),
    GET_DETAIL: build("/api/Warehouse/GetDetail?"),
    GET_LIST: build("/api/Warehouse/GetList?"),
    CREATE: build("/api/Warehouse/Create"),
    UPDATE: build("/api/Warehouse/Update"),
    DELETE: build("/api/Warehouse/Delete"),
    UPDATE_DEFAULT: build("/api/Warehouse/UpdateDefault"),
  },
  // ==================== VEHICLE_TYPE ====================
  VEHICLE_TYPE: {
    BASE: build("/api/VehicleType"),
    GET_DETAIL: build("/api/VehicleType/GetDetail?"),
    GET_LIST: build("/api/VehicleType/GetList?"),
    GET_LIST_FOR_SELECT: build("/api/VehicleType/GetListForSelect?"),
    CREATE: build("/api/VehicleType/Create"),
    UPDATE: build("/api/VehicleType/Update"),
    DELETE: build("/api/VehicleType/Delete"),
  },
  // ==================== VEHICLE ====================
  VEHICLE: {
    BASE: build("/api/Vehicle"),
    GET_DETAIL: build("/api/Vehicle/GetDetail?"),
    GET_LIST: build("/api/Vehicle/GetList?"),
    GET_LIST_FOR_SELECT: build("/api/Vehicle/GetListForSelect?"),
    CREATE: build("/api/Vehicle/Create"),
    UPDATE: build("/api/Vehicle/Update"),
    DELETE: build("/api/Vehicle/Delete"),
    GET_TRANSPORTATION_MODE_LIST: build(
      "/api/Vehicle/GetTransportationModeList",
    ),
    GET_EWAYBILL_VEHICLE_TYPE_LIST: build(
      "/api/Vehicle/GetEWayBillVehicleTypeList",
    ),
  },
  // ==================== USER ====================
  USER: {
    BASE: build("/api/User"),
    GET_DETAIL_BY_ID: build("/api/User/GetDetailById?"),
    GET_DETAIL: build("/api/User/GetDetail?"),
    GET_LIST: build("/api/User/GetList?"),
    CREATE: build("/api/User/Create"),
    GET_SAVE_USER_FIRM_BRANCH_SELECTION: build(
      "/api/User/GetSaveUserFirmBranchSelection?",
    ),
    DELETE: build("/api/User/Delete"),
    UPDATE: build("/api/User/Update"),
    CHANGE_PASSWORD: build("/api/User/ForgotPassword"),
    SEND_INVITE: build("/api/User/SendInvite"),
    REINVITE: build("/api/User/ReInvite"),
    UPDATE_DEFAULT_INVOICE: build("/api/User/UpdateDefaultInvoice"),
    UPDATE_DEFAULT_LR: build("/api/User/UpdateDefaultLR"),
    GET_USER_ROLE_LIST: build("/api/User/GetUserRoleList?"),
    UPDATE_DEFAULT_VOUCHER: build("/api/User/UpdateDefaultVoucher"),

  },
  USER_GROUP: {
    BASE: build("/api/UserGroup"),
    GET_DETAIL: build("/api/UserGroup/GetDetail?"),
    GET_LIST: build("/api/UserGroup/GetList?"),
    GET_LIST_FOR_SELECT: build("/api/UserGroup/GetListForSelect?"),
    CREATE: build("/api/UserGroup/Create"),
    UPDATE: build("/api/UserGroup/Update"),
    DELETE: build("/api/UserGroup/Delete"),
    GET_MEMBER_LIST: build("/api/UserGroup/GetUserGroupMemberList?"),
    TRANSFER_MEMBERS: build("/api/UserGroup/TransferMembers"),
  },
  USER_GROUP_ACCESS: {
    BASE: build("/api/UserGroupAccess"),
    GET_USER_GROUP_MENU_ACCESS: build(
      "/api/UserGroupAccess/GetUserGroupMenuAccess?",
    ),
    GET_USER_GROUP_LIST: build("/api/UserGroupAccess/GetUserGroupList?"),
    GET_MENU_ACCESS: build("/api/UserGroupAccess/GetMenuAccess?"),
    CREATE: build("/api/UserGroupAccess/Create"),
  },
  UNIT: {
    BASE: build("/api/Unit"),
    GET_DETAIL: build("/api/Unit/GetDetail?"),
    GET_LIST: build("/api/Unit/GetList?"),
    GET_LIST_BY_PRODUCT: build("/api/Unit/GetListByType?"),
    GET_LIST_FOR_SELECT: build("/api/Unit/GetListForSelect?"),
    CREATE: build("/api/Unit/Create"),
    UPDATE: build("/api/Unit/Update"),
    DELETE: build("/api/Unit/Delete"),
  },
  // ==================== BRANCH ====================
  BRANCH: {
    BASE: build("/api/Branch"),
    LIST: build("/api/Branch"),
    GET_LIST: build("/api/Branch/GetList?"),
    GET: build("/api/Branch/{id}"),
    CREATE: build("/api/Branch/Create"),
    UPDATE: build("/api/Branch/Update"),
    DELETE: build("/api/Branch/Delete/{id}"),
    SEARCH: build("/api/Branch/Search"),
    EXPORT: build("/api/Branch/Export"),
    GET_DETAIL: build("/api/Branch/GetDetail?"),
    GET_LIST_FOR_SELECT: build("/api/Branch/GetListForSelect?"),
    ON_POST_UPLOAD_ASYNC: build("/api/Branch/OnPostUploadAsync"),
    ON_POST_TEST_FILE_FORM_ASYNC: build("/api/Branch/OnPostTestFileFormAsync"),
  },
  // ==================== BUYER ====================
  BUYER: {
    BASE: build("/api/Buyer"),
    LIST: build("/api/Buyer"),
    GET: build("/api/Buyer/{id}"),
    CREATE: build("/api/Buyer/Create"),
    UPDATE: build("/api/Buyer/Update"),
    DELETE: build("/api/Buyer/Delete"),
    SEARCH: build("/api/Buyer/Search"),
    EXPORT: build("/api/Buyer/Export"),
    GET_DETAIL: build("/api/Buyer/GetDetail?"),
    GET_LIST: build("/api/Buyer/GetList?"),
    GET_LIST_FOR_AREA: build("/api/Buyer/GetListForArea?"),
    GET_BUYER_LIST_FOR_RECEIPT: build("/api/Buyer/GetBuyerListForReceipt?"),
    GET_BUYER_LIST_FOR_FIELD_SELECT: build(
      "/api/Buyer/GetBuyerListForFieldSelect?",
    ),
  },

  BUSINESSTYPE: {
    BASE: build("/api/BusinessType"),
    LIST: build("/api/BusinessType/GetList?"),
    LIST_FOR_SELECT: build("/api/BusinessType/GetListForSelect?"),
  },

  CATEGORY: {
    BASE: build("/api/Category"),
    LIST: build("/api/Category"),
    GET_LIST: build("/api/Category/GetList?"),
    GET: build("/api/Category/{id}"),
    CREATE: build("/api/Category/Create"),
    UPDATE: build("/api/Category/Update"),
    DELETE: build("/api/Category/Delete"),
    SEARCH: build("/api/Category/Search"),
    EXPORT: build("/api/Category/Export"),
    GET_DETAIL: build("/api/Category/GetDetail?"),
    GET_LIST_FOR_CATEGORY_TYPE: build("/api/Category/GetListForCategoryType"),
  },

  CITY: {
    BASE: build("/api/City"),
    LIST: build("/api/City"),
    GET: build("/api/City/{id}"),
    CREATE: build("/api/City/Create"),
    UPDATE: build("/api/City/Update"),
    DELETE: build("/api/City/Delete/{id}"),
    SEARCH: build("/api/City/Search"),
    EXPORT: build("/api/City/Export"),
  },

  CONSUMER: {
    BASE: build("/api/Consumer"),
    LIST: build("/api/Consumer"),
    GET: build("/api/Consumer/{id}"),
    CREATE: build("/api/Consumer/Create"),
    UPDATE: build("/api/Consumer/Update"),
    DELETE: build("/api/Consumer/Delete/{id}"),
    SEARCH: build("/api/Consumer/Search"),
    EXPORT: build("/api/Consumer/Export"),
  },

  CREDIT_NOTE: {
    BASE: build("/api/CreditNote"),
    LIST: build("/api/CreditNote"),
    GET: build("/api/CreditNote/{id}"),
    CREATE: build("/api/CreditNote/Create"),
    UPDATE: build("/api/CreditNote/Update"),
    DELETE: build("/api/CreditNote/Delete/{id}"),
    SEARCH: build("/api/CreditNote/Search"),
    EXPORT: build("/api/CreditNote/Export"),
  },

  DEBIT_NOTE: {
    BASE: build("/api/DebitNote"),
    LIST: build("/api/DebitNote"),
    GET: build("/api/DebitNote/{id}"),
    CREATE: build("/api/DebitNote/Create"),
    UPDATE: build("/api/DebitNote/Update"),
    DELETE: build("/api/DebitNote/Delete/{id}"),
    SEARCH: build("/api/DebitNote/Search"),
    EXPORT: build("/api/DebitNote/Export"),
  },

  DASHBOARD: {
    BASE: build("/api/Dashboard"),
    STATS: build("/api/Dashboard/Stats"),
    SUMMARY: build("/api/Dashboard/Summary"),
  },

  DOCUMENT: {
    BASE: build("/api/Document"),
    UPLOAD: build("/api/Document/Upload"),
    DOWNLOAD: build("/api/Document/Download/{id}"),
    DELETE: build("/api/Document/Delete/{id}"),
    LIST: build("/api/Document"),
  },

  FIRM: {
    BASE: build("/api/Firm"),
    LIST: build("/api/Firm"),
    GET: build("/api/Firm/{id}"),
    CREATE: build("/api/Firm/Create"),
    UPDATE: build("/api/Firm/Update"),
    DELETE: build("/api/Firm/Delete/{id}"),
  },

  GST: {
    BASE: build("/api/GST"),
    LIST: build("/api/GST"),
    GET: build("/api/GST/{id}"),
    CREATE: build("/api/GST/Create"),
    UPDATE: build("/api/GST/Update"),
    DELETE: build("/api/GST/Delete/{id}"),
  },

  INVOICE: {
    BASE: build("/api/Invoice"),
    LIST: build("/api/Invoice"),
    GET: build("/api/Invoice/{id}"),
    CREATE: build("/api/Invoice/Create"),
    UPDATE: build("/api/Invoice/Update"),
    DELETE: build("/api/Invoice/Delete/{id}"),
    EXPORT: build("/api/Invoice/Export"),
  },

  LEDGER: {
    BASE: build("/api/Ledger"),
    LIST: build("/api/Ledger"),
    GET: build("/api/Ledger/{id}"),
    CREATE: build("/api/Ledger/Create"),
    UPDATE: build("/api/Ledger/Update"),
    DELETE: build("/api/Ledger/Delete/{id}"),
  },

  NOTIFICATION: {
    BASE: build("/api/Notification"),
    LIST: build("/api/Notification"),
    READ: build("/api/Notification/Read/{id}"),
    UNREAD_COUNT: build("/api/Notification/UnreadCount"),
  },

  PAYMENT: {
    BASE: build("/api/Payment"),
    LIST: build("/api/Payment"),
    GET: build("/api/Payment/{id}"),
    CREATE: build("/api/Payment/Create"),
  },

  PRODUCT: {
    BASE: build("/api/Product"),
    LIST: build("/api/Product"),
    GET: build("/api/Product/{id}"),
    CREATE: build("/api/Product/Create"),
    UPDATE: build("/api/Product/Update"),
    DELETE: build("/api/Product/Delete/{id}"),
    SEARCH: build("/api/Product/Search"),
    GET_LIST_FOR_PRODUCT_TYPE: build("/api/Product/GetListForProductType"),
    GET_DETAIL: build("/api/Product/GetDetail?"),
    GET_LAST_PRODUCT: build("/api/Product/GetLastProduct?"),
    GET_LIST_FOR_BATCHWISE: build("/api/Product/GetListForBatchWise?"),
    GET_LIST_FOR_PURCHASE: build("/api/Product/GetListForPurchase?"),
    GET_LIST_FOR_NOTES: build("/api/Product/GetListForNotes?"),
    GET_LIST_FOR_SALE: build("/api/Product/GetListForSale?"),
    GET_LIST_FOR_STOCK_ADJ: build("/api/Product/GetListForStockAdj?"),
    GET_PRODUCT_BARCODE: build("/api/Product/GetProductBarcode?"),
    GENERATE_PRODUCT_BARCODE: build("/api/Product/GenerateProductBarcode?"),
    FREE_GOOD_SUMMARY_BY_CATEGORY_LIST: build(
      "/api/Product/FreeGoodSummaryByCategoryList?",
    ),
    FREE_GOODS_DETAIL_BY_BUYER_LIST: build(
      "/api/Product/FreeGoodsDetailByBuyerList?",
    ),
    FREE_GOODS_SUMMARY_BY_BUYER_LIST: build(
      "/api/Product/FreeGoodsSummaryByBuyerList?",
    ),
  },

  CHALLAN: {
    BASE: build("/api/Challan"),
    GET_DETAIL: build("/api/Challan/GetDetail?"),
    GET_LIST: build("/api/Challan/GetList?"),
    CREATE: build("/api/Challan/Create"),
    UPDATE: build("/api/Challan/Update"),
    DELETE: build("/api/Challan/Delete"),
    GET_CHALLAN_LAST_DETAIL: build("/api/Challan/GetChallanLastDetail?"),
    GET_CHALLAN_NUMBER: build("/api/Challan/GetChallanNumber?"),
    GET_CHALLAN_DUE_SUMMARY_LIST: build(
      "/api/Challan/GetChallanDueSummaryList?",
    ),
    GET_CHALLAN_DUE_DETAIL_LIST: build("/api/Challan/GetChallanDueDetailList?"),
  },

  PURCHASE: {
    BASE: build("/api/Purchase"),
    LIST: build("/api/Purchase"),
    GET: build("/api/Purchase/{id}"),
    CREATE: build("/api/Purchase/Create"),
    UPDATE: build("/api/Purchase/Update"),
    DELETE: build("/api/Purchase/Delete/{id}"),
  },

  SALE: {
    BASE: build("/api/Sale"),
    LIST: build("/api/Sale"),
    GET: build("/api/Sale/{id}"),
    CREATE: build("/api/Sale/Create"),
    UPDATE: build("/api/Sale/Update"),
    DELETE: build("/api/Sale/Delete/{id}"),
    EXPORT: build("/api/Sale/Export"),
  },

  SALE_DRAFT: {
    BASE: build("/api/SaleDraft"),
    GET_LIST: build("/api/SaleDraft/GetList?"),
    GET_DETAIL: build("/api/SaleDraft/GetDetail?"),
    CREATE: build("/api/SaleDraft/Create"),
    UPDATE: build("/api/SaleDraft/Update"),
    DELETE: build("/api/SaleDraft/Delete"),
  },

  STOCK: {
    BASE: build("/api/Stock"),
    LIST: build("/api/Stock"),
    GET: build("/api/Stock/{id}"),
    CREATE: build("/api/Stock/Create"),
    UPDATE: build("/api/Stock/Update"),
    DELETE: build("/api/Stock/Delete/{id}"),
  },

  STAFF: {
    BASE: build("/api/Staff"),
    LIST: build("/api/Staff"),
    GET: build("/api/Staff/{id}"),
    CREATE: build("/api/Staff/Create"),
    UPDATE: build("/api/Staff/Update"),
    DELETE: build("/api/Staff/Delete/{id}"),
  },

  SUPPLIER: {
    BASE: build("/api/Supplier"),
    LIST: build("/api/Supplier"),
    GET: build("/api/Supplier/GetDetail?"),
    GET_LIST_FOR_SELECT: build("/api/Supplier/GetListForSelect?"),
    GET_LIST_FOR_FIELD_SELECT: build(
      "/api/Supplier/GetSupplierListForFieldSelect?",
    ),
    GET_LIST_FOR_PAYMENT: build("/api/Supplier/GetSupplierListForPayment?"),
    CREATE: build("/api/Supplier/Create"),
    UPDATE: build("/api/Supplier/Update"),
    DELETE: build("/api/Supplier/Delete"),
  },

  TRIAL_BALANCE: {
    BASE: build("/api/TrialBalance"),
    GET_TRIAL_BALANCE: build("/api/TrialBalance/GetTrialBalance?"),
  },

  TRANSPORTATION_MASTER: {
    BASE: build("/api/TransportationMaster"),
    GET_TRANSPORTATION_MODE_LIST: build(
      "/api/TransportationMaster/GetTransportationModeList",
    ),
    GET_TRANSPORTATION_VEHICLE_TYPE_LIST: build(
      "/api/TransportationMaster/GetTransportationVehicleTypeList",
    ),
    GET_DETAIL: build("/api/TransportationMaster/GetDetail?"),
    GET_LIST: build("/api/TransportationMaster/GetList?"),
    CREATE: build("/api/TransportationMaster/Create"),
    UPDATE: build("/api/TransportationMaster/Update"),
    DELETE: build("/api/TransportationMaster/Delete"),
  },

  TRANSACTION_MODE: {
    BASE: build("/api/TransacitionMode"),
    GET_LIST_TRANSACTION_MODE_FOR_SELECT: build(
      "/api/TransacitionMode/GetListTransactionModeForSelect?",
    ),
  },

  SYSTEM_CONFIGURATION: {
    BASE: build("/api/SystemConfiguration"),
    GET_CONFIGURATIONS: build("/api/SystemConfiguration/GetConfigurations?"),
    CREATE: build("/api/SystemConfiguration/Create"),
    UPDATE: build("/api/SystemConfiguration/Update"),
    GET_BY_ID: build("/api/SystemConfiguration/GetSystemConfiguration?"),
  },

  SUBSCRIPTION: {
    BASE: build("/api/Subscription"),
    GET_DETAIL: build("/api/Subscription/GetDetail?"),
    GET_DETAIL_FOR_CONSUMER: build("/api/Subscription/GetDetailForConsumer?"),
    CREATE: build("/api/Subscription/Create"),
    UPDATE: build("/api/Subscription/Update"),
  },

  SUBSCRIPTION_DRAFT: {
    BASE: build("/api/SubscriptionDraft"),
    GET_DETAIL: build("/api/SubscriptionDraft/GetDetail?"),
    CREATE: build("/api/SubscriptionDraft/Create"),
    UPDATE: build("/api/SubscriptionDraft/Update"),
  },

  STOCK_TRANSFER: {
    BASE: build("/api/StockTransfer"),
    CREATE: build("/api/StockTransfer/Create"),
    UPDATE: build("/api/StockTransfer/Update"),
    GET_STOCK_TRANSFER_NO: build("/api/StockTransfer/GetStockTransferNumber?"),
    LIST: build("/api/StockTransfer/GetList?"),
    GET_DETAIL: build("/api/StockTransfer/GetDetail?"),
    DELETE: build("/api/StockTransfer/Delete"),
  },

  TAX: {
    BASE: build("/api/Tax"),
    LIST: build("/api/Tax"),
    GET: build("/api/Tax/{id}"),
    CREATE: build("/api/Tax/Create"),
    UPDATE: build("/api/Tax/Update"),
    DELETE: build("/api/Tax/Delete/{id}"),
  },

  DOCTOR: {
    BASE: build("/api/Doctor"),
    LIST: build("/api/Doctor/GetList?"),
    GET: build("/api/Doctor/GetDetail?"),
    CREATE: build("/api/Doctor/Create"),
    UPDATE: build("/api/Doctor/Update"),
    DELETE: build("/api/Doctor/Delete"),
  },
  MANUFACTURING_JOURNAL: {
    BASE: build("/api/ManufacturingJournal"),
    LIST: build("/api/ManufacturingJournal/GetList?"),
    GET: build("/api/ManufacturingJournal/GetDetail?"),
    GET_VOUCHER_NO: build("/api/ManufacturingJournal/GetVoucherNumber?"),
    CREATE: build("/api/ManufacturingJournal/Create"),
    UPDATE: build("/api/ManufacturingJournal/Update"),
    DELETE: build("/api/ManufacturingJournal/Delete"),
    APPROVE: build("/api/ManufacturingJournal/Approve"),
  },
} as const;
